import AssistantScreen from '@/components/Assistant/AssistantScreen';

export default AssistantScreen;
